import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { TextFormattedNumber } from 'components';
import round from 'helpers/mathRound';
import {
  FormControl,
  Grid,
  TextField,
  Typography
} from '@material-ui/core';
import { getQuoteProductSubscriptionOptionsApi } from 'api';
import { getAlleDiscount } from 'pages/quotes/helpers';
import { useStyles } from '../../../styles';


const QuoteItemSelect = ({ formik, index, item }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const {
    quoteProductsByGroup,
    subscriptionOptionsBySku
  } = useSelector((state: IReduxState) => state.quote);

  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched
  } = formik;

  const {
    selectedItemGroup,
    sku
  } = item;

  const handleItemSelectionChange = async (event, value) => {
    setLoading(true);
    handleChange(event);
    const { sku, custom_attributes, price } = value;

    const itemGroup = selectedItemGroup ? selectedItemGroup : custom_attributes.find((attr) => attr.attribute_code === 'catalog_quotepro_groups')?.value?.toString().split(',')[0];
    const isAlleSKU = sku.includes('bdsku');
    const itemSavings = isAlleSKU
      ? round(getAlleDiscount(value)) || 0
      : custom_attributes.find((attr) => attr.attribute_code === 'savings')?.value || 0;

    const itemAdditionalSubscriptionPrice = custom_attributes.find((attr) => attr.attribute_code === 'additional_subscription_price')?.value || 0;

    if (!subscriptionOptionsBySku?.[sku] && sku) {
      await getQuoteProductSubscriptionOptionsApi({ dispatch, sku });
    }

    const product = {
      selectedItemGroup: itemGroup,
      sku,
      qty: 1,
      fixedPrice: price,
      subscription_id: '',
      discountType: '',
      subscriptionFrequency: '',
      additional_subscription_price: itemAdditionalSubscriptionPrice,
      savings: itemSavings,
      discount: '',
    };

    setFieldValue(`items[${index}]`, product);
    setLoading(false);
  };

  const selectedGroup = selectedItemGroup || values.selectedGroup;
  const selectedItem = quoteProductsByGroup?.[selectedGroup]?.find((product) => product.sku == sku || null);
  const additionalSubscriptionPrice = selectedItem?.custom_attributes?.find((attr) => attr.attribute_code === 'additional_subscription_price')?.value || 0;

  useEffect(() => {
    !selectedItem && setFieldTouched(`items[${index}].sku`, true, true);
  }, [selectedItem, setFieldTouched, index]);

  const selectedSKUs = values.items.map((item) => item.sku);

  return (
    <Grid item xs={12} lg={2}>
      <FormControl variant="outlined" fullWidth>
        <Autocomplete
          disableClearable
          onChange={(event, value) => handleItemSelectionChange(event, value)}
          onBlur={handleBlur}
          options={quoteProductsByGroup?.[selectedGroup] || []}
          value={selectedItem || ''}
          disabled={!selectedItemGroup || loading}
          getOptionLabel={(option) => option?.name || ''}
          getOptionDisabled={(option) => selectedSKUs.includes(option.sku) || option?.type_id === 'configurable'}
          size="small"
          fullWidth
          classes={{
            inputRoot: classes.autocompleteInput,
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              name={`items[${index}].sku`}
              label="Select Item"
              error={touched.items?.[index]?.sku && !!errors.items?.[index]?.sku}
              helperText={touched.items?.[index]?.sku && errors.items?.[index]?.sku}
            />
          )}
        />
      </FormControl>
      {!!additionalSubscriptionPrice &&
        <Grid item xs={12} sm={12} md={12} lg={12} className="pt-0 mb-4">
          <Typography variant="caption">
            Per month, paid annually:&nbsp;
            <TextFormattedNumber
              value={additionalSubscriptionPrice}
              prefix="$"
            />
          </Typography>
        </Grid>
      }
    </Grid>
  );
};

export default QuoteItemSelect;
